var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconViewlistWhite = function SvgIconViewlistWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3-1a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2zm0 13a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zM9 12a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m-3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    "data-follow-fill": "currentColor"
  })));
};
export default SvgIconViewlistWhite;